const TrashIcon = ({ size = 20 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.5 5H4.16667H17.5'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.66663 4.99999V3.33332C6.66663 2.8913 6.84222 2.46737 7.15478 2.15481C7.46734 1.84225 7.89127 1.66666 8.33329 1.66666H11.6666C12.1087 1.66666 12.5326 1.84225 12.8451 2.15481C13.1577 2.46737 13.3333 2.8913 13.3333 3.33332V4.99999M15.8333 4.99999V16.6667C15.8333 17.1087 15.6577 17.5326 15.3451 17.8452C15.0326 18.1577 14.6087 18.3333 14.1666 18.3333H5.83329C5.39127 18.3333 4.96734 18.1577 4.65478 17.8452C4.34222 17.5326 4.16663 17.1087 4.16663 16.6667V4.99999H15.8333Z'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.33337 9.16667V14.1667'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.6666 9.16667V14.1667'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default TrashIcon
